import styled, { css, ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { StyledDivComponent } from '../types';

interface HamburgerContainerProps {
  active?: boolean;
}

type HamburgerContainerPropsThemed = ThemeProps<Theme> &
  HamburgerContainerProps;

export const HamburgerContainer: StyledDivComponent<
  HamburgerContainerProps
> = styled.div`
  position: absolute;
  right: 20px;
  top: 24px;

  div {
    position: relative;
    overflow: visible;
    cursor: pointer;
    transition-timing-function: linear;
    transition-duration: 0.15s;
    transition-property: opacity, filter;
    color: inherit;
    width: 24px;
    height: 16px;
  }

  span {
    top: 50%;
    display: block;
    margin-top: -2px;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    transition-duration: 75ms;
    position: absolute;
    width: 100%;
    height: 2px;
    transition-timing-function: ease;
    transition-duration: 0.15s;
    transition-property: transform;
    background-color: ${(props: HamburgerContainerPropsThemed) =>
      props.theme.colors.secondary};

    &:after,
    &:before {
      position: absolute;
      width: 100%;
      height: 2px;
      transition-timing-function: ease;
      transition-duration: 0.15s;
      transition-property: transform;
      background-color: ${(props: HamburgerContainerPropsThemed) =>
        props.theme.colors.secondary};
    }

    &:before,
    &:after {
      display: block;
      content: '';
    }

    &:before {
      top: -6px;
      transition: top 75ms ease 0.12s, opacity 75ms ease;
    }

    &:after {
      bottom: -6px;
      transition: bottom 75ms ease 0.12s,
        transform 75ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    ${(props: HamburgerContainerPropsThemed) =>
      props.active &&
      css`
        transition-delay: 0.12s;
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transform: rotate(45deg);

        &:before {
          top: 0;
          transition: top 75ms ease, opacity 75ms ease 0.12s;
          opacity: 0;
        }

        &:after {
          bottom: 0;
          transition: bottom 75ms ease,
            transform 75ms cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
          transform: rotate(-90deg);
        }
      `}
  }
`;
